import { Component } from '@angular/core';

@Component({
  selector: 'app-produto-cp',
  templateUrl: './cdc-loja.component.html'
})
export class CdcLojaComponent {}
